import { render, staticRenderFns } from "./HgTosText.vue?vue&type=template&id=fc5ffd40&scoped=true&"
import script from "./HgTosText.vue?vue&type=script&lang=js&"
export * from "./HgTosText.vue?vue&type=script&lang=js&"
import style0 from "./HgTosText.vue?vue&type=style&index=0&id=fc5ffd40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5ffd40",
  null
  
)

export default component.exports